// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-task-due-date.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($task_id: uuid!, $due_date: timestamp!) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $task_id }
    _set: { due_date: $due_date }
  ) {
    id
  }
}

`